import React from 'react';
import InputField from '../../../Forms/Input/InputField';

interface EWalletPaymentSectionProps {
  voucherCode: string;
  onVoucherChange: (value: string) => void;
}

const EWalletPaymentSection: React.FC<EWalletPaymentSectionProps> = ({
  voucherCode,
  onVoucherChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onVoucherChange(e.target.value);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <InputField
        label="Código de Referencia"
        name="eWalletVoucher"
        iconKey="payment" // puedes cambiarlo si tienes un ícono específico
        type="text"
        placeholder="Ingrese el código del monedero"
        value={voucherCode}
        onChange={handleChange}
      />
    </div>
  );
};

export default EWalletPaymentSection;
